
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { _common } from './_common';

@Component({
    selector: 'app-signup-error',
    templateUrl: './signup.error.component.html',
    standalone: true
})
export class SignupErrorComponent {


  _common = _common;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {

  }


  back() {
    let app = this.route.snapshot.queryParamMap.get('app')
    this.router.navigate(['/signup'], {
      queryParams: { app: app }
    });
  }

}
